import { connect } from "react-redux";
import Welcome from "../../components/app/Welcome";
import { setSource, setStage, Stages } from "../../actions/actions";
import { getFromQueryString } from "../../actions/services";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onNext: () => {
      //   dispatch(setStage(Stages.sendOtp));
      dispatch(setStage(Stages.login));
    },
    onSetSource: () => {
      let source = getFromQueryString("source") || "";

      dispatch(setSource(source));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    source: state.session.app.source,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/app/Welcome.js